import { AnimatePresence, motion } from "framer-motion";
import styled from "styled-components";
interface ITooltip {
  children: React.ReactNode;
  handleClose: any;
}

const dropIn = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
};

export const Tooltip = ({ children, handleClose }: ITooltip) => {
  return (
    <AnimatePresence>
      <TpBack onClick={handleClose} onDrag={handleClose}>
        <TooltipStyled
          onClick={(e) => e.stopPropagation()}
          variants={dropIn}
          initial="hidden"
          animate="visible"
          exit="hidden"
        >
          {children}
        </TooltipStyled>
      </TpBack>
    </AnimatePresence>
  );
};

const TooltipStyled = styled(motion.div)`
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 15px;
  background-color: #222222;
  border-radius: 12px;
  color: white;
  width: 240px;
`;

const TpBack = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;
